var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _g, _g2, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOpenMenuBackgroundTopLeft = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "OpenMenuBackground_TopLeft",
  x: "0px",
  y: "0px",
  viewBox: "0 0 689.1 855.9",
  stqyle: "enable-background:new 0 0 689.1 855.9;",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.stq0{fill:#38555A;}\r\n\t.stq1{display:none;}\r\n\t.stq2{display:inline;fill:none;}\r\n\t.stq3{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  className: "stq0",
  points: "46,1 1,38 1,440.2 54,410.2 54,66 70,54 196,54 221,1 "
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  className: "stq0",
  points: "243.6,1 221,53.8 254.5,53.5 276.4,1 "
})), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  className: "stq0",
  points: "287.4,1 264.8,53.8 298.3,53.5 320.2,1 "
})), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
  className: "stq0",
  points: "331.2,1 308.6,53.8 342.1,53.5 364,1 "
})), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
  className: "stq0",
  points: "375,1 352.4,53.8 385.9,53.5 407.8,1 "
})), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
  className: "stq0",
  points: "418.8,1 396.2,53.8 429.7,53.5 451.6,1 "
})), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
  className: "stq0",
  points: "462.6,1 440,53.8 473.5,53.5 495.4,1 "
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "rightlines",
  className: "stq1"
}, /*#__PURE__*/React.createElement("polyline", {
  className: "stq2",
  points: "505.4,-3 1765.9,-3 1843.7,74.8 1843.7,956 1779.4,1020.4 832,1020.4 863,946 1742,946 1767.5,922.5  1767.5,631 1843.7,594.6  "
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "leftlines",
  className: "stq1"
}, /*#__PURE__*/React.createElement("polyline", {
  className: "stq2",
  points: "65.4,590.2 65.4,984.2 147.6,1066.4 1785.7,1066.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "stq2",
  points: "1.8,955.1 54.6,977.6 54.3,944.1 1.8,922.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "stq2",
  points: "1.8,911.3 54.6,933.8 54.3,900.3 1.8,878.4  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "stq2",
  points: "1.8,867.5 54.6,890 54.3,856.5 1.8,834.6  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "stq2",
  points: "1.8,823.7 54.6,846.2 54.3,812.7 1.8,790.8  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "stq2",
  points: "1.8,779.9 54.6,802.4 54.3,768.9 1.8,747  "
}), /*#__PURE__*/React.createElement("polygon", {
  className: "stq2",
  points: "1.8,736.1 54.6,758.6 54.3,725.1 1.8,703.2  "
}))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  className: "stq3",
  points: "689.1,1 46,1 1,38 1,855.9 "
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpenMenuBackgroundTopLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/OpenMenuBackground_TopLeft.c54fd8ee.svg";
export { ForwardRef as ReactComponent };